import type { AdditionalFieldDelegate } from "@firecms/core";
import { EventContentReleaseChips } from "../collections/EventContentBundlePreview";
import type { Event } from "../collections/events";

export function buildEventContentBundleField(): AdditionalFieldDelegate<Event> {
  return {
    key: "contentReleasePublish",
    name: "Publicación",
    width: 220,
    dependencies: ["contentReleaseRef", "status"],
    Builder: ({ entity }) => (
      <EventContentReleaseChips
        contentReleaseRef={entity.values.contentReleaseRef}
        status={entity.values.status}
        eventPath={`${entity.path}/${entity.id}`}
      />
    ),
  };
}
